import React from 'react';
import MaterialHealthcare from './MaterialHealthcare';

export default class SpouseHealthcare extends MaterialHealthcare {
  static forSpouse = true;
}
